import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "hash",
	routes: [
    {
      path: '/',
      component: require('@/pages/Index').default,
      children: [
      ]
    },
		{
			path: "/help",
			component: require("@/pages/Help").default
		},
		{
			path: "/doc/:doc_name",
			component: require("@/pages/Doc").default,
		},
    {
      path: '*',
      redirect: '/'
    }
  ]
})
